import { render, staticRenderFns } from "./educatorProjects.vue?vue&type=template&id=65823c3c"
import script from "./educatorProjects.vue?vue&type=script&lang=js"
export * from "./educatorProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports